// extracted by mini-css-extract-plugin
export var currencySymbol = "currency-field-module--currencySymbol--qP7vI";
export var input = "currency-field-module--input--hmi+5";
export var symbolAfter = "currency-field-module--symbolAfter--bsvmb";
export var wrap = "currency-field-module--wrap--EyuPE";